namespace TabAurous.Inventory {
    export namespace BranchInService {
        export const baseUrl = 'Inventory/BranchIn';

        export declare function Create(request: Serenity.SaveRequest<BranchInRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<BranchInRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<BranchInRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<BranchInRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Custom(request: AuthorizationRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CheckIfAuthorized(request: TransactionRequest, onSuccess?: (response: Serenity.RetrieveResponse<BranchInRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/BranchIn/Create",
            Update = "Inventory/BranchIn/Update",
            Delete = "Inventory/BranchIn/Delete",
            Retrieve = "Inventory/BranchIn/Retrieve",
            List = "Inventory/BranchIn/List",
            Custom = "Inventory/BranchIn/Custom",
            CheckIfAuthorized = "Inventory/BranchIn/CheckIfAuthorized"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Custom', 
            'CheckIfAuthorized'
        ].forEach(x => {
            (<any>BranchInService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
